<template>
  <div class="modal is-wide" @click.self="cancel">
    <div class="modal-container is-animated scale-up">
      <header class="modal-header">{{ __('Enter URL') }}</header>
      <div class="modal-body">
        <input
          ref="input"
          v-model="url"
          :class="{ invalid: url && !validUrl }"
          type="url"
          :placeholder="inputPlaceholder"
          autofocus
          novalidate
          @keyup.enter="save"
        />
        <div>
          <div v-show="!url" class="small-type muted-type">
            {{
              __(
                'We support all kinds of URLs — images, YouTube, Google Drive, Soundcloud, articles, blogs, you name it.',
              )
            }}
          </div>
          <div v-show="url && !validUrl" class="small-type error-type">{{ __('Please enter a valid link.') }}</div>
        </div>
      </div>
      <footer class="modal-footer">
        <button class="text-button" @click="cancel">{{ __('Cancel') }}</button>
        <button class="text-button" :disabled="!validUrl" @click="save">{{ __('Save') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { isUrl } from 'bits/url'
import { extractUrl } from 'bits/html_parser'
import { __ } from 'bits/intl'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'

export default {
  mixins: [EscapeToCancelMixin],
  data() {
    return {
      url: '',
      inputPlaceholder: __('E.g. %{example}', { example: 'https://drive.google.com/mydocument' }),
    }
  },
  computed: {
    validUrl() {
      if (isUrl(this.url)) {
        return this.url
      }
      if (isUrl(`http://${this.url}`)) {
        return `http://${this.url}`
      }
      const extractedUrl = extractUrl(this.url)
      if (extractedUrl) {
        return extractedUrl
      }
      return null
    },
  },
  mounted() {
    this.$refs.input.focus()
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    save() {
      if (this.validUrl) {
        this.$emit('select', this.validUrl)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
small {
  line-height: 1.25;
}
input + div {
  height: 48px;
}
</style>
